// extracted by mini-css-extract-plugin
export default {"albumButton":"Home_albumButton__kAJ3y","header":"Home_header__bNbBh","playButton":"Home_playButton__D4jo4","containers":"Home_containers__AEEO9","tourTitle":"Home_tourTitle__CwjKA"};